import Vue from "vue";
import InputText from "../components/inputs/InputText.vue";
import InputTextArea from "../components/inputs/InputTextArea.vue";
import InputSelect from "../components/inputs/InputSelect.vue";
import SelectWithInfinite from "@/components/inputs/SelectWithInfinite.vue";
import Pagination from "@/components/Pagination.vue";

Vue.component("InputText", InputText);
Vue.component("InputTextArea", InputTextArea);
Vue.component("InputSelect", InputSelect);
Vue.component("SelectWithInfinite", SelectWithInfinite);
Vue.component("Pagination", Pagination);
